import { pipe } from '../../../shared/misc';

const filterByIsActive = (list) => list.filter((item) => item.isActive);
const filterByHasComponents = (list) => list.filter((item) => item.componentsToCore?.length);
const takeComponentsToCore = (list) => list.map((item) => item.componentsToCore);
const flatten = (list) => list.flat();

export const getComponentList = pipe(
  Object.values,
  filterByHasComponents,
  filterByIsActive,
  takeComponentsToCore,
  flatten
);
